import { api, getErrorMessage } from "./client";

export type CheckoutReferencePayload = {
  deliveryDetails: string;
  deliveryFee: number;
  serviceFee: number;
  deliveryContact: string;
  deliveryContact2?: string[];
  orderType: string;
  deliveryDateOption: string;
  displayAmount: number;
  discount: number;
  gamified?: Array<{
    remarksType: string;
    discountAmountApplied: number;
  }>;
};

export async function createCheckoutReference(
  userId: string,
  payload: CheckoutReferencePayload,
): Promise<string> {
  try {
    const res = await api.post(
      `/checkout-references/checkout-reference-ao/${userId}`,
      payload,
    );

    const data = res.data?.data ?? res.data;
    return (
      data?.checkoutReference ??
      data?._id ??
      data?.referenceId ??
      data?.id ??
      ""
    );
  } catch (err: any) {
    throw new Error(getErrorMessage(err));
  }
}

export async function abandonCheckoutReference(
  userId: string,
): Promise<void> {
  try {
    await api.patch(
      `/checkout-references/checkout-reference/abandon/${userId}`,
    );
  } catch {
  
  }
}
